import * as yup from 'yup'

export class VehicleCheckInManufacturersLabelPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInManufacturersLabelPhotoFile?: File = undefined
  vehicleCheckInIsManufacturersLabelPhotoMissing?: boolean = undefined
  vehicleCheckInManufacturersLabelMissingNote?: string = undefined
}

export const vehicleCheckInManufacturersLabelPhotoValidationSchema = yup.object({
  vehicleCheckInManufacturersLabelPhotoFile: yup.mixed().nullable(),
  vehicleCheckInIsManufacturersLabelPhotoMissing: yup.boolean().nullable(),
  vehicleCheckInManufacturersLabelMissingNote: yup
    .string()
    .nullable()
    .when('vehicleCheckInIsManufacturersLabelPhotoMissing', {
      is: true,
      then: schema =>
        schema
          .max(200, 'Manufacturer Label Missing Note cannot be more than 200 characters.')
          .required("Manufacturer Label Missing Note is required when Manufacturer's Label is missing.")
    })
})
